import { StreetPage } from './StreetPage';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { dealTypeSelector } from 'store/state/selectors/search';
import { streetListCountSelector } from 'store/state/domainData/selectors';
import { resolvedStrictLocalDocSelector, cityDocIdSelector } from 'store/state/domainData/selectors';
import { articlesSelector } from 'components/blog-carousel/street-page';


const mapStateToProps = (state: State) => ({
  resolvedAddress: resolvedStrictLocalDocSelector(state),
  cityDocId: cityDocIdSelector(state),
  dealType: dealTypeSelector(state),
  totalPoi: streetListCountSelector(state),
  articles: articlesSelector(state),
});

export default connect(mapStateToProps)(StreetPage);
